"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BEHAVIOR_EVENT = void 0;
var BEHAVIOR_EVENT;
(function (BEHAVIOR_EVENT) {
    BEHAVIOR_EVENT["SEND_PRIZE_SUCCESS"] = "SEND_PRIZE_SUCCESS";
    BEHAVIOR_EVENT["SEND_PRIZE_FAIL"] = "SEND_PRIZE_FAIL";
    BEHAVIOR_EVENT["TASK_COMPLETED"] = "TASK_COMPLETED";
    BEHAVIOR_EVENT["TASK_EXPIRED"] = "TASK_EXPIRED";
})(BEHAVIOR_EVENT || (exports.BEHAVIOR_EVENT = BEHAVIOR_EVENT = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW51bS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImVudW0udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsSUFBWSxjQUtYO0FBTEQsV0FBWSxjQUFjO0lBQ3hCLDJEQUF5QyxDQUFBO0lBQ3pDLHFEQUFtQyxDQUFBO0lBQ25DLG1EQUFpQyxDQUFBO0lBQ2pDLCtDQUE2QixDQUFBO0FBQy9CLENBQUMsRUFMVyxjQUFjLDhCQUFkLGNBQWMsUUFLekIifQ==